/**
 * Bonus indicator types.
 *
 * @class BonusIndicatorTypes
 * @memberof Mojito.Modules
 */
export default class BonusIndicatorTypes {}

/**
 * BonusIndicator TYPES enum, used for selecting bonus icons, labels, etc.
 *
 * @typedef TYPES
 * @property {string} EARLY_PAYOUT - Early Payout bonus type.
 * @property {string} ODDS_BOOST - Odds boost bonus type.
 * @property {string} ACCA_BOOST - Acca Boost bonus type.
 * @property {string} ACCA_INSURANCE - Acca Insurance bonus type.
 * @property {string} ENHANCED_EW_TERMS - Enhanced EW Terms bonus type.
 * @property {string} BEST_ODDS_GUARANTEED - Best Odds Guaranteed bonus type.
 * @property {string} EVENT_TRIGGERED - Event Triggered bonus type.
 * @memberof Mojito.Modules.BonusIndicatorTypes
 */
BonusIndicatorTypes.TYPES = {
    EARLY_PAYOUT: 'EARLY_PAYOUT',
    ODDS_BOOST: 'ODDS_BOOST',
    ACCA_BOOST: 'ACCA_BOOST',
    ACCA_INSURANCE: 'ACCA_INSURANCE',
    ENHANCED_EW_TERMS: 'ENHANCED_EW_TERMS',
    BEST_ODDS_GUARANTEED: 'BEST_ODDS_GUARANTEED',
    EVENT_TRIGGERED: 'EVENT_TRIGGERED',
};
